import React, { useEffect, useState } from 'react'
import Member from '../../assets/images/Member.png'
import ChevronRight from '../../assets/images/Chevron Right.png'

import Copier from '../agents/components/Copier';

//import { getAgentResultsService } from '../../services/result.service';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLoading, setToastMessage } from '../../reducers/common.reducer';
import { getUserWinLossByDateService } from '../../services/winloss.service';
import { selectUserData } from '../../reducers/user.reducer';

const ProfitSharing = () => {
    const [isSaveFormVisible, setIsSaveFormVisible] = useState(false)
    const [resultData, setResultData] = useState([]);
    const [fromDateToDate, setFromDateToDate] = useState("")
    const [agentDetailData, setAgentDetailData] = useState({});

    const userData = useSelector(selectUserData);

    const toggleCopierForm = () => {
        setIsSaveFormVisible(!isSaveFormVisible)
    }

    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so we add 1
    let day = String(currentDate.getDate()).padStart(2, '0');

    let formattedDate = `${year}-${month}-${day}`;

    const date = new Date(); // Current date
    date.setDate(date.getDate() - 7); // Subtract 7 days
    const [toUser, setToUser] = useState({ 'userId': '', 'name': '' });
   // console.log(date.toISOString().split('T')[0]);
    const [startDate, setStartDate] = useState(date.toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(formattedDate);

    // useEffect(() => {
    //     setToUser({
    //         'userId': userData?.userInfo?.userId,
    //         'name': userData?.userInfo?.name
    //     });
    // }, [userData]);



    let dispatch = useDispatch();

    async function getWinLossResult () {

        // if(toUser.userId === '')
        //     setToUser({
        //         'userId': userData?.userInfo?.userId,
        //         'name': userData?.userInfo?.name
        //     });

        try {
            dispatch(setIsLoading(true))
            let payload = {startDate, endDate}
            console.log(payload);

            //let userId= userData?.userInfo?.userId
            let user = JSON.parse(localStorage.getItem("USER"))
            let result = await getUserWinLossByDateService(payload, user.userId )
            if(result.data) {
            setResultData(result.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }
    useEffect(()=> {
        getWinLossResult();
    }, [startDate, endDate])



    const overallTotals = resultData && resultData.reduce((acc, agent) => {
        acc.totalWinLoss += 1 * agent.userWinLoss;
        return acc;
    }, { totalWinLoss: 0});



    return (
        <div onClick={()=> setIsSaveFormVisible(false)}>
            <div className='w-[90%] mx-auto borderColor h-[88vh]'>

                {/* URL Section */}
                <div className="flex gap-2 pt-2 pb-2">
                    <img src={Member} alt="member-logo" className='w-6 fgColor' />
                    <p className="font-bold text-fgColor">/</p>
                    <p className="font-bold text-fgColor">User</p>
                    <p className="font-bold text-fgColor">/</p>
                    <p className="font-bold text-fgColor">{`Profit Sharing for  user: ${userData?.userInfo?.username} `}</p>
                </div>

                {/* Date-Picker, Input, `Set` Button Section */}
                <div className="bg-white mx-auto p-7 mt-8 flex justify-between flex-wrap rounded">
                    <div
                    onClick={(e)=> e.stopPropagation()}
                    className="flex gap-10">
                        <div className='flex gap-3 items-center'>
                            <label htmlFor="startDate" className='text-black'>From</label>
                            <input
                                name='startDate'
                                type="date"
                                value={startDate}
                                className='bg-bgColor text-userText rounded p-2 px-5 outline-none'
                                onChange={(e)=> setStartDate(e.target.value)}
                            />
                        </div>
                        <div className='flex gap-3 items-center text-black'>
                            <label htmlFor="endDate">To</label>
                            <input
                                name='endDate'
                                type="date"
                                value={endDate}
                                className='bg-bgColor text-userText rounded p-2 px-5 outline-none'
                                onChange={(e)=> setEndDate(e.target.value)}
                            />
                        </div>
                        {/* <input
                            type="text"
                            placeholder='Day. 10/09 to 12/09'
                            className='bg-bgColor pl-5  outline-none '
                            onChange={(e)=> setFromDateToDate(e.target.value)}
                        />
                        <button
                            type='submit'
                            className='px-16 py-2 bg-primary text-white rounded'>
                            Set
                        </button> */}
                    </div>
                </div>

                {/* Table and Total Section */}
                <div className="bg-white h-[78%] overflow-y-auto flex items-center justify-center">
                    { !!resultData.length ?
                    (
                    <div className=" mt-2 pl-7 w-[80%]">

                        <table className="mb-10 w-full">
                            <thead className='border-b-2'>
                                <th className="px-4 py-4 text-fgColor">Game Type</th>
                                <th className="px-4 py-4 text-fgColor">Total Win Loss Amt.</th>
                                <th className="px-4 py-4 text-fgColor">Percent</th>
                                <th className="text-right px-4 py-4 text-fgColor">User Win Loss Amt.</th>
                                <th className="px-4 py-4 text-fgColor"></th>
                            </thead>
                            <tbody>
                                {
                                !!resultData.length &&  resultData?.map((result) => {
                                        return (
                                            <tr className='border-b-2' key={result.id}>
                                                <td className="text-left py-4 px-4 text-fgColor font-semibold pl-16">{result?.gameType}</td>
                                                <td className="text-left py-4 px-4 text-fgColor font-semibold pl-16">{result?.total}</td>
                                                <td className="text-left py-4 px-4 text-fgColor font-semibold pl-16">{result?.percent}</td>
                                                <td className="text-right py-4 px-4 text-fgColor font-semibold">{result?.userWinLoss}</td>
                                                {/* <td>
                                                    <img
                                                        src={ChevronRight}
                                                        onClick={ (e) => {
                                                            e.stopPropagation()
                                                            setIsSaveFormVisible(true)
                                                            setAgentDetailData(result)
                                                           // setAgentId(result.agentId)
                                                            }
                                                        }
                                                        alt="chevron-right-logo"
                                                        className="w-6 ml-10 fgColor cursor-pointer"
                                                    />
                                                </td> */}
                                            </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>

                        <div className="flex justify-end">
                            <div className="flex gap-10 mr-10 ">
                                <p
                                className="text-left text-black font-bold">
                                    Total WinLoss:
                                </p>
                                <p className="mb-10 text-black font-bold">
                                    {  overallTotals?.totalWinLoss }
                                </p>

                            </div>
                        </div>
                    </div>
                    )
                    :
                        ( <div className='flex  justify-center h-full w-full'>
                                <div className='mt-40'>
                                    {`No Data Between: ${ startDate } and ${endDate} `}
                                </div>
                        </div>
                        )
                    }
                </div>

                {/* Copier Component */}
                <Copier
                    isSaveFormVisible={isSaveFormVisible}
                    onClick={toggleCopierForm}
                    date={startDate}
                    agentDetailData={agentDetailData}
                    fromDateToDate={fromDateToDate}
                />

                <div className="h-10"></div>
            </div>
        </div>
    )
}

export default ProfitSharing
